<template>
<div >
	<Navbar></Navbar>
	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class=" container" v-if="!loading">	
			
			<div class="alert alert-warning mt-2" v-if="car.status=='PRE_ADMITTED' && car.admission_estimated_at">
				<i class="fa fa-clock-o"></i> Fecha de ingreso estimada para el día {{car.admission_estimated_at | moment("dddd DD [de] MMMM, YYYY ")}}
			</div>

			<div class="alert alert-warning mt-2" v-if="car.status=='DELIVERY_SCHEDULED' && car.delivery_scheduled_at">
				<i class="fa fa-clock-o"></i> Entrega programada para el día {{car.delivery_scheduled_at | moment("dddd DD [de] MMMM, YYYY [a las ] HH:mm")}} hrs.
			</div>
			
			<div class="alert alert-success mt-2" v-if="car.status=='DELIVERED' && car.delivered_at">
				<i class="fa fa-clock-o"></i> Entregado el día {{car.delivered_at | moment("dddd DD [de] MMMM, YYYY ")}}
			</div>

			<div class="alert alert-success mt-2" v-if="car.authorized">
				<i class="fa fa-check"></i> El vehículo ha sido autorizado para entregar al concesionario: {{car.delivery_to_carrier}}
			</div>

			<div class="row row-xs mt-2">
				<div class="col col-md-4">
					
					<div class="card" >
						<div class="data" style="width:100%">
							<div class="car-side">
								<div class="car-title">
									<div class="brand" v-if="car.brand.logo" :style="{backgroundImage:`url(${API_URL+car.brand.logo.urlThumb})`}"></div>
									<div class="title">
										<p class="m-0">{{ car.brand.title }}</p>
										<h2>{{car.model}}</h2>
										<p class="m-0"><small>{{car.model_particular}} - {{car.color.title}}</small></p>
									</div>
								</div>
							</div>
							
							<div class="pill">	
								<div class="data">
									<h6 class="mt-2">
										VEHÍCULO
									</h6>
									<table class="table table-borderless table-sm ">
										<tr>
											<td >Chasis</td> <td>{{car.chassis_number}}</td>
										</tr>
										<tr>
											<td >Motor</td> <td>{{car.motor_number}}</td>
										</tr>
										<!-- <tr>
											<td >Tipo</td> <td>{{car.category.title}}</td>
										</tr> -->
										<tr v-if="car.internal_number">
											<td >N interno</td> <td>{{car.internal_number}}</td>
										</tr>
									</table>
								</div>
							</div>

							<div class="pill">	
								<div class="data">
									<!-- <div class="btn btn-success" @click="$refs.carCarRequestDispatch.open()" v-if="car.canRequestDispatch">Solicitar despacho</div> -->
									<div class="btn btn-success mt-2" @click="$refs.carRequestPreDelivery.open()" v-if="car.canRequestPreDelivery">Solicitar Pre entrega</div>
									<div class="btn btn-success mt-2" @click="$refs.carRequestDelivery.open()" v-if="car.canRequestDelivery">Solicitar entrega</div>
								</div>
							</div>
							
							<div class="pill">	
								<div class="data">

									<h6 class="mt-3">CLIENTE</h6>
									<table class="table table-borderless table-sm ">
										<tr>
											<td >Cliente</td> <td>{{car.client.name}}</td>
										</tr>
										<!-- <tr>
											<td >Razón social</td> <td>{{car.client.business_name}}</td>
										</tr>
										<tr>
											<td >Email</td> <td>{{car.client.email}}</td>
										</tr> -->
									</table>

									<div v-if="car.dua_transit || car.dua_stock || car.dua_dispatch || car.dispatch_file" >
										<h6 class="mt-3">DUA</h6>
										<table class="table table-borderless table-sm ">
											<tr v-if="car.dua_transit">
												<td >DUA Tránsito</td> <td><strong>{{car.dua_transit}}</strong></td>
											</tr>
											<tr v-if="car.dua_stock">
												<td >Stock</td> <td><strong>{{car.dua_stock}}</strong></td>
											</tr>
											<tr v-if="car.dua_dispatch">
												<td ><strong>DUA Despacho</strong></td> <td><strong>{{car.dua_dispatch}}</strong></td>
											</tr>
											<tr v-if="car.dispatch_file">
												<td ><strong>Comprobante</strong></td> 
												<td >
													<strong>
														<a class="" target="_blank" :href="API_URL+car.dispatch_file.url">
															{{car.dispatch_file.filename}}.{{car.dispatch_file.extension}}
														</a>
													</strong>
												</td>
											</tr>
										</table>

									</div>

									
									<!-- <h6 class="mt-3">UBICACIÓN</h6>
									<table class="table table-borderless table-sm " v-if="car.parkingSlot">
										<tr>
											<td >
												{{car.parkingSlot.deposit.title}}
												<strong>{{car.parkingSlot.code}}</strong>
											</td>
										</tr>
									</table>
									<div v-else class="alert alert-sm alert-danger mt-1 text-center">
										Sin ubicación asignada
									</div> -->

									<h6 class="mt-3">ESTADO</h6>
									<table class="table table-borderless table-sm ">
										<tr>
											<td ><div class="car-status-point" :class="car.status"></div>{{car.statusText}}</td>
										</tr>
									</table>
								</div>
							</div>


							<div class="pill d-none d-sm-block">
								<div class="data">
									<h6 class="mt-2">DAÑOS</h6>

									<table class="table table-clickeable table-borderless table-sm ">
										<tr  v-for="damage in car.damages" :key="damage.id" @click="openDamage(damage,car)">
											<td>
												<strong>{{damage.typeText}}</strong><br>
												{{damage.description}}
											</td>
											
											<td class="text-right">
												<div class="text-success" v-if="damage.status==1"><div class="car-status-point DELIVERED" ></div>Reparado</div>
												<strong v-if="damage.charge">U$S {{damage.charge.price}}</strong>
											</td>
											
										</tr>
									</table>
								</div>
							</div>

							<div class="pill d-none d-sm-block">
								<div class="data">
									<h6 class="mt-2">CARGOS</h6>

									<table class="table table-borderless table-sm ">
										<tr v-for="charge in car.charges" :key="charge.id">
											<td>
												<strong>{{charge.description}}</strong>
											</td>
											<td class="text-right no-wrap">
												<strong>U$S {{charge.price}}</strong>
											</td>
										</tr>
									</table>
									
									<div class="d-flex mt-2">
										<h5 class="">TOTAL</h5>
										<h5 class="ml-auto">U$S {{car.chargesTotal}}</h5>
									</div>
								</div>
							</div>
							
							
							<!-- <div class="pill d-none d-sm-block">
								<div class="data">
									<h6 class="mt-2">LOGS</h6>
									<CarActivity :activity="car.logs"></CarActivity>
								</div>
							</div> -->


						</div>
					</div>
				</div>

				<div class="col col-md-8">

					<div class="activity-stream">
						
						<div class="item mb-3" v-for="control in car.controls" :key="control.id" 
							:class="{
								'by-client':control.type=='REQUEST_PRE_DELIVERY' || control.type=='REQUEST_DISPATCH' || control.type=='REQUEST_DELIVERY'
							}">
							<div class="head">
								<label>
									{{control.typeText}}
									<span class="badge badge-warning mr-2" v-if="control.priority=='MEDIUM'">Prioridad Media</span>	
									<span class="badge badge-danger mr-2" v-if="control.priority=='HIGH'">Prioridad Alta</span>	
								</label>
								<div class="date d-flex">
									<div>
										{{control.created_at | moment('dddd DD [de] MMM YYYY')}} <br>
									</div>
								</div>
							</div>


							<div class="content" >

								<div v-if="control.type=='ADMISSION' || control.type=='DAMAGES'">
									
									<div v-if="control.damages.length>0">
										<h6 class="mt-3">Daños</h6>
										<div class="damage-list">
											<div class="damage"  v-for="damage in control.damages" :key="damage.id" @click="openDamage(damage,car)">
												<div class="map-content">
													<div class="map" :style="{backgroundImage: `url('${ require('@/assets/img/carsDraws/'+car.category.draw+'/'+damage.side+'.png') }')` }" >
														<div >
															<div class="point animated bounceIn"
																:style="`left:${damage.position.left}%; top:${damage.position.top}%`" 
																:class="[damage.type.toLowerCase()]"
															>
															</div>
														</div>
													</div>
												</div>
												<div class="detail">
													<strong><small>{{damage.typeText}}</small></strong><br>
													Responsabilidad: <span v-if="damage.responsible=='INTERNAL'">Interna</span>
													<span v-if="damage.responsible=='CLIENT'">Cliente</span>
													<span v-if="damage.responsible=='THIRD'">Tercero</span>
													<br>
													{{damage.description}}
												</div>
												<div class="images images-sm">
													<div class="image" v-for="image in damage.images" :key="image.id">
														<div class="background" :style="'background-image:url('+API_URL+image.urlThumb+')'"></div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div v-else>
										<p>Vehículo ingresado sin daños ni faltantes</p>
									</div>
									
									<div v-if="control.missings.length>0">
										<h6 class="mt-3 mb-2">Faltantes</h6>
										<p class="ml-2" v-for="missing in control.missings" :key="missing.id">
											<strong>-</strong> {{missing.description}}
											<br>
											Responsabilidad: <span v-if="missing.responsible=='INTERNAL'">Interna</span>
											<span v-if="missing.responsible=='CLIENT'">Cliente</span>
											<span v-if="missing.responsible=='THIRD'">Tercero</span>
											<br>
										</p>
									</div>

									<div v-if="control.truck_mat">
										<h6 class="mt-3">Conductor responsable</h6>
										<table class="table table-sm table-labeled-30">
											<tr>
												<td><strong>Matrícula</strong></td>
												<td>{{control.truck_mat}}</td>
											</tr>
											<tr>
												<td><strong>Conductor</strong></td>
												<td>{{control.truck_driver_name}}</td>
											</tr>
											<tr>
												<td><strong>Firma</strong></td>
												<td v-if="control.truck_driver_signature"><img :src="control.truck_driver_signature" class="img-fluid"></td>
												<td v-else>No se ha podido registrar la firma</td>
											</tr>
										</table>
									</div>
									

								</div>

								<div v-if="control.type=='PRE_DELIVERY'">
									<table class="table table-sm table-labeled-30">
										<tr>
											<td><strong>Lubricantes</strong></td>
											<td>
												<p v-for="lubricant in control.lubricants" :key="lubricant.id">
													<strong>-</strong> {{lubricant.lubricant.title}} <strong class="ml-2"> {{lubricant.liters}}L</strong>
												</p>
											</td>
										</tr>
										<!-- <tr>
											<td><strong>Mano de obra</strong></td>
											<td>
												{{control.labor_hours | moment('HH:mm')}} hrs.
											</td>
										</tr> -->
										<tr>
											<td><strong>Pulido</strong></td>
											<td>
												<span v-if="control.polished=='total'">Pulido total </span>
												<span v-if="control.polished=='partial'">Parcial - Se han pulido {{control.polished_pieces}} piezas</span>
												<span v-if="control.polished=='none'">No se han pulido piezas</span>
											</td>
										</tr>
										<tr>
											<td><strong>Carga de gas</strong></td>
											<td>
												<span v-if="control.gas_charge">Si</span>
												<span v-else>No</span>
											</td>
										</tr>
									</table>

									<div class="alert alert-sm mt-2 alert-warning" v-if="control.has_damages">Se han detectado daños</div>

								</div>

								<div v-if="control.type=='DELIVERY'">
									
									<div v-if="control.damages.length>0">
										<h6 class="mt-3">Daños</h6>
										<div class="damage-list">
											<div class="damage"  v-for="(damage, damageIndex) in control.damages" :key="damage.id" @click="openDamage(damage,car)" >
												<div class="map-content">
													<div class="map" :style="{backgroundImage: `url('${ require('@/assets/img/carsDraws/'+car.category.draw+'/'+damage.side+'.png') }')` }" >
														<div >
															<div class="point animated bounceIn"
																:style="`left:${damage.position.left}%; top:${damage.position.top}%`" 
																:class="[damage.type.toLowerCase()]"
																:ref="`damage_${damageIndex}`" 
															>
															</div>
														</div>
													</div>
												</div>
												<div class="detail">
													<strong><small>{{damage.typeText}}</small></strong><br>
													{{damage.description}}
												</div>
												<div class="images images-sm">
													<div class="image" v-for="image in damage.images" :key="image.id">
														<div class="background" :style="'background-image:url('+API_URL+image.urlThumb+')'"></div>
													</div>
												</div>
												
											</div>
										</div>
									</div>
									<div v-else>
										<p>Vehículo entregado sin daños ni faltantes</p>
									</div>
									
									<div v-if="control.missings.length>0">
										<h6 class="mt-3 mb-2">Faltantes</h6>
										<p class="ml-2" v-for="missing in control.missings" :key="missing.id">
											<strong>-</strong> {{missing.description}}
										</p>
									</div>

									<div v-if="control.truck_mat">
										<h6 class="mt-3">Entregado a</h6>
										<table class="table table-sm table-labeled-30">
											<tr>
												<td><strong>Matrícula</strong></td>
												<td>{{control.truck_mat}}</td>
											</tr>
											<tr>
												<td><strong>Conductor</strong></td>
												<td>{{control.truck_driver_name}}</td>
											</tr>
											<tr>
												<td><strong>Firma</strong></td>
												<td v-if="control.truck_driver_signature"><img :src="control.truck_driver_signature" class="img-fluid"></td>
												<td v-else>No se ha podido registrar la firma</td>
											</tr>
										</table>
									</div>
								</div>

								<div v-if="control.type=='TRANSFER-OUT'">
									<div class="pl-2 mb-2">	
										<table class="table table-sm table-labeled-30">
											<tr>
												<td><strong>Destino del vehículo</strong></td>
												<td>{{control.transfer_to}}</td>
											</tr>
										</table>
									</div>
								</div>
								
								<div v-if="control.type=='TRANSFER-IN'">
									<div class="pl-2 mb-2">	
										<table class="table table-sm table-labeled-30">
											<tr>
												<td><strong>Recibido por</strong></td>
												<td>{{control.transfer_received_by}}</td>
											</tr>
											<tr>
												<td><strong>Firma</strong></td>
												<td v-if="control.transfer_received_by_signature"><img :src="control.transfer_received_by_signature" class="img-fluid"></td>
												<td v-else>No se ha podido registrar la firma</td>
											</tr>
										</table>
									</div>
								</div>								

								<div v-if="control.type=='REQUEST_DELIVERY'">
									<div>
										<table class="table table-sm table-labeled-30 table-borderless table-transparent" >
											<tr >
												<td><strong>Empresa / concesionario que retira</strong></td>
												<td>{{car.delivery_to_business}}</td>
											</tr>
											<tr>
												<td><strong>Nombre transportista</strong></td>
												<td>{{car.delivery_to_carrier}}</td>
											</tr>
											<tr>
												<td><strong>Fecha sugerida de retiro</strong></td>
												<td>{{car.delivery_requested_at | moment('DD-MM-YYYY')}}</td>
											</tr>
										</table>
									</div>

								</div>

								<div v-if="control.files.length>0">
									<h6 class="mt-3">Adjuntos</h6>
									<FileList :files="control.files" size="sm"></FileList>
								</div>

								<div v-if="control.comments">
									<h6 class="mt-3">Comentarios</h6>
									<p>{{control.comments}}</p>
								</div>
							</div>
						</div>

						<div v-if="car.controls.length==0" class="alert alert-warning">
							No se han registrado controles en este vehículo
						</div>
					</div>

				</div>

			</div>

		</div>
	</div>

	<DamageView ref="damageView" @changed="load()"></DamageView>
	<CarRequestDispatch ref="carCarRequestDispatch" v-if="car" :carId="car.id" @changed="load()" />
	<CarRequestPreDelivery ref="carRequestPreDelivery" v-if="car" :carId="car.id" @changed="load()" />
	<CarRequestDelivery ref="carRequestDelivery" v-if="car" :carId="car.id" @changed="load()" />
</div>
</template>


<script>
import gql from 'graphql-tag'
import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import FileList from '@/components/FileList'
import DamageView from '@/components/DamageView'
import CarActivity from '@/views/cars/CarActivity'
import UploadFile from '@/components/UploadFile'

import CarRequestDispatch from '@/views/cars/CarRequestDispatch'
import CarRequestPreDelivery from '@/views/cars/CarRequestPreDelivery'
import CarRequestDelivery from '@/views/cars/CarRequestDelivery'


export default {
	name: 'carsView',
	components:{
		Navbar,
		CarActivity,
		Loader,
		FileList,
		DamageView,
		CarRequestDispatch,
		CarRequestPreDelivery,
		CarRequestDelivery,
	},
	data () {
		return {
			API_URL: process.env.VUE_APP_API_URL,
			tabActive: this.$route.query.tab,
			loading: true,
			toggleFilters: false,
			car: {},

		}
	},
	beforeMount(){
		this.load();
	},
	methods:{
		openDamage(damage, car){
			this.$refs.damageView.open(damage, car)
		},
		load(){
			this.$apollo.query({
				query: gql`query getCar($id: ID!) {
					car(id: $id) {
						id
						client{
                            name
                        }
                        brand{
                            title
                            logo{
								urlThumb
							}
                        }
						model
						category{
							title
							draw
						}
                        dua_transit
                        dua_stock
                        dua_dispatch
						dispatch_file{
							id
							filename
							extension
							url
						}
                        motor_number
                        chassis_number
                        model_particular
						internal_number
                        color{
                            title
                        }
                        status
						statusText
						comments
						admission_estimated_at
						joined_at
						delivery_requested_at
						delivery_scheduled_at
						delivery_to_business
						delivery_to_carrier
						delivered_at

						authorized
						delivery_to_carrier
						
						canRequestDispatch
						canRequestPreDelivery
						canRequestDelivery
						
						controls{
							id
							user{
								name
							}
							type
							typeText
							lubricants{
								lubricant{
									title
								}
								liters
							}
							priority
							priorityText
							labor_hours
							polished
							polished_pieces
							gas_charge
							has_damages
							comments
							files{
								id
								url
								urlThumb
								type
								filename
								extension
							}
							damages{
								id
								side
								images{
									id
									url
									urlThumb
									type
									filename
									extension
								}
								position{
									top
									left
								}
								type
								typeText
								description
								responsible
								status
								statusText
							}
							missings{
								responsible
								description
							}
							truck_mat
							truck_driver_name
							truck_driver_signature

							transfer_to
							transfer_received_by
							transfer_received_by_signature

							created_at
						}
						charges{
							description
							price
						}
						chargesTotal
						damages{
							id
							side
							images{
								id
								url
								urlThumb
								type
								filename
								extension
							}
							position{
								top
								left
							}
							charge{
								id
								price
							}
							type
							typeText
							description
							status
						}
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					id: this.$route.params.id,
				},
			})
			.then((data) => {
				this.car = data.data.car
				this.loading = false
			})
			.catch(() => {
				// this.$router.push('/')
			})
		},
		openTab(tab){
			this.$router.replace({ query: { tab}  } );
		},

		requestDelivery(){
			console.log()
		}
		
	}
}


</script>

<style scoped lang="scss">
.car-title{
    display:flex;
    align-items: center;
	text-align: left;
	flex-direction: column;

    .brand{
        width: 72px;
        height: 72px;
        border-radius: 100%;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        background-color:#fff;
        border: solid #fff 3px;
	}
	
	.title{
		text-align:center;

		p{
			font-size: 15px;
		}
		h2{
			font-size: 19px;
		}
	}

}


.activity-stream{

	.item{
		background-color:#fff;
		margin-bottom:4px;
		padding: 14px;

		&.by-client{
			background-color: #fdebd1;
		}
		.head{
			display:flex;
			justify-content:space-between;
			align-items: center;

			label{
				font-weight: 600;
				margin: 0px;
			}
			.date{
				color: #516f90;
				font-size: 12px;
				text-align: right;
				line-height: 14px;

				span{
					color: #009fe3;
				}
			}
		}

		.content{
			padding: 8px;
		}

	}
}

.inline-textarea{
	background-color:#f3f3f3;
	border-radius: 2px;
	width: 100%;
	padding: 4px;
}



</style>
